import {GetSafeValue} from "../utils/get-safe-value";
import {ControlFormNameUtil} from "../utils/string-control-form-name";
import {trackByHourSegment} from "angular-calendar/modules/common/util";

export class Payment {

  private _khqrMerchantId : string;
  private _isAcledaEnable:boolean;
  private _isABAEnable: boolean;
  private _isPiPayEnable: boolean;
  private _isMasterCardEnable: boolean;
  private _isWingEnable: boolean;
  private _isAmkQrEnable: boolean;
  private _isAmkPayEnable: boolean;
  private _isAmkDeeplinkEnable: boolean;
  private _typeKHQRPayment: string;
  private _khqrCurrency: string;
  private _aba : ABAPayment;
  private _acleda : ACLEDAPayment;
  private _staticQr : StaticQr;

  constructor(){
    this.typeKHQRPayment= "";
    this.khqrMerchantId = "";
    this.isAcledaEnable = true;
    this.isABAEnable = true;
    this.isPiPayEnable = true;
    this.isMasterCardEnable = true;
    this.isWingEnable = true;
    this.isAmkPayEnable = true;
    this.isAmkDeeplinkEnable = true;
    this.isAmkQrEnable = true;
    this.aba = new ABAPayment();
    this.acleda = new ACLEDAPayment();
    this.staticQr = new StaticQr();
  }

  clone(data: Payment) {
    this.typeKHQRPayment = data.typeKHQRPayment;
    this.khqrCurrency = data.khqrCurrency;
    this.khqrMerchantId = data.khqrMerchantId;
    this.isAcledaEnable = data.isAcledaEnable;
    this.isABAEnable = data.isABAEnable;
    this.isPiPayEnable = data.isPiPayEnable;
    this.isMasterCardEnable = data.isMasterCardEnable;
    this.isWingEnable = data.isWingEnable;
    this.isAmkQrEnable = data.isAmkQrEnable;
    this.isAmkPayEnable = data.isAmkPayEnable;
    this.isAmkDeeplinkEnable = data.isAmkDeeplinkEnable;
    if(data.aba){
      this.aba.clone(data.aba);
    }else{
      this.aba = new ABAPayment();
    }
    if(data.acleda){
      this.acleda.clone(data.acleda);
    }else{
      this.acleda = new ACLEDAPayment();
    }
    if(data.staticQr){
      this.staticQr.clone(data.staticQr);
    }else{
      this.staticQr = new StaticQr();
    }

  }

  fromJson(data: Payment){
    this.khqrMerchantId = GetSafeValue.getSafeValueAsString(data[ControlFormNameUtil.khqrMerchantId], null);
    this.typeKHQRPayment = GetSafeValue.getSafeValueAsString(data[ControlFormNameUtil.typeKHQRPayment], null);
    this.khqrCurrency = GetSafeValue.getSafeValueAsString(data[ControlFormNameUtil.khqrCurrency], null);
    this.isAcledaEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.cfnIsAcledaEnable], true);
    this.isABAEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.cfnIsABAEnable], true);
    this.isPiPayEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.cfnIsPiPayEnable], true);
    this.isMasterCardEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.cfnIsMasterCardEnable], true);
    this.isWingEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.isWingEnable], true);
    this.isAmkQrEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.isAmkQrEnable], true);
    this.isAmkPayEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.isAmkPayEnable], true);
    this.isAmkDeeplinkEnable = GetSafeValue.getSafeValueAsBoolean(data[ControlFormNameUtil.isAmkDeeplinkEnable], true);

    if(data['aba']){
      this.aba.fromJson(data['aba']);
    }
    if(data['acleda']){
      this.acleda.fromJson(data['acleda']);
    }

    if(data['staticQr']){
      this.staticQr.fromJson(data['staticQr']);
    }

  }

  toMap(){
    return {
      'khqrMerchantId' : this.khqrMerchantId ? this.khqrMerchantId : null,
      'typeKHQRPayment' : this.typeKHQRPayment ? this.typeKHQRPayment : null,
      'khqrCurrency' : this.khqrCurrency ? this.khqrCurrency : null,
      'isAcledaEnable': this.isAcledaEnable,
      'isABAEnable': this.isABAEnable,
      'isPiPayEnable': this.isPiPayEnable,
      'isMasterCardEnable': this.isMasterCardEnable,
      'isWingEnable': this.isWingEnable,
      'isAmkQrEnable': this.isAmkQrEnable,
      'isAmkPayEnable': this.isAmkPayEnable,
      'isAmkDeeplinkEnable': this.isAmkDeeplinkEnable,
      'aba' : this.aba.toMap(),
      'acleda' : this.acleda.toMap(),
      'staticQr' : this.staticQr.toMap()
    };
  }


  get staticQr(): StaticQr {
    return this._staticQr;
  }

  set staticQr(value: StaticQr) {
    this._staticQr = value;
  }

  get aba(): ABAPayment {
    return this._aba;
  }

  set aba(value: ABAPayment) {
    this._aba = value;
  }

  get acleda(): ACLEDAPayment {
    return this._acleda;
  }

  set acleda(value: ACLEDAPayment) {
    this._acleda = value;
  }

  get khqrCurrency(): string {
    return this._khqrCurrency;
  }

  set khqrCurrency(value: string) {
    this._khqrCurrency = value;
  }

  get typeKHQRPayment(): string {
    return this._typeKHQRPayment;
  }

  set typeKHQRPayment(value: string) {
    this._typeKHQRPayment = value;
  }

  get khqrMerchantId(): string {
    return this._khqrMerchantId;
  }

  set khqrMerchantId(value: string) {
    this._khqrMerchantId = value;
  }

  get isAcledaEnable(): boolean {
    return this._isAcledaEnable;
  }

  set isAcledaEnable(value: boolean) {
    this._isAcledaEnable = value;
  }

  get isABAEnable(): boolean {
    return this._isABAEnable;
  }

  set isABAEnable(value: boolean) {
    this._isABAEnable = value;
  }

  get isPiPayEnable(): boolean {
    return this._isPiPayEnable;
  }

  set isPiPayEnable(value: boolean) {
    this._isPiPayEnable = value;
  }

  get isMasterCardEnable(): boolean {
    return this._isMasterCardEnable;
  }

  set isMasterCardEnable(value: boolean) {
    this._isMasterCardEnable = value;
  }

  get isWingEnable(): boolean {
    return this._isWingEnable;
  }

  set isWingEnable(value: boolean) {
    this._isWingEnable = value;
  }

  get isAmkQrEnable(): boolean {
    return this._isAmkQrEnable;
  }

  set isAmkQrEnable(value: boolean) {
    this._isAmkQrEnable = value;
  }

  get isAmkPayEnable(): boolean {
    return this._isAmkPayEnable;
  }

  set isAmkPayEnable(value: boolean) {
    this._isAmkPayEnable = value;
  }

  get isAmkDeeplinkEnable(): boolean {
    return this._isAmkDeeplinkEnable;
  }

  set isAmkDeeplinkEnable(value: boolean) {
    this._isAmkDeeplinkEnable = value;
  }

}

export  class ABAPayment {

  public merchantId: string;
  public merchantName: string;
  public apiKey: string;

  constructor(){
    this.merchantId = '';
    this.merchantName = '';
    this.apiKey = '';

  }

  clone(data: ABAPayment) {
    this.merchantId = data.merchantId;
    this.merchantName = data.merchantName;
    this.apiKey = data.apiKey;
  }

  fromJson(data: ABAPayment){
    this.merchantId = GetSafeValue.getSafeValueAsString(data["merchantId"], null);
    this.merchantName = GetSafeValue.getSafeValueAsString(data["merchantName"], null);
    this.apiKey = GetSafeValue.getSafeValueAsString(data["apiKey"], null);

  }

  toMap(){
    return {
      'merchantId' : this.merchantId ? this.merchantId : null,
      'merchantName' : this.merchantName ? this.merchantName : null,
      'apiKey' : this.apiKey ? this.apiKey : null,
    };
  }

}

export  class ACLEDAPayment {
  private _merchantId: string;
  private _merchantName: string;
  private _apiKey: string;
  private _loginId: string;
  private _password: string;

  constructor(){
    this.merchantId = '';
    this.merchantName = '';
    this.apiKey = '';
  }

  clone(data: ACLEDAPayment) {
    this.merchantId = data.merchantId;
    this.merchantName = data.merchantName;
    this.apiKey = data.apiKey;
  }

  fromJson(data: ACLEDAPayment){
    this.merchantId = GetSafeValue.getSafeValueAsString(data["merchantId"], null);
    this.merchantName = GetSafeValue.getSafeValueAsString(data["merchantName"], null);
    this.apiKey = GetSafeValue.getSafeValueAsString(data["apiKey"], null);
    this.loginId = GetSafeValue.getSafeValueAsString(data["loginId"], null);
    this.password = GetSafeValue.getSafeValueAsString(data["password"], null);
  }

  get merchantId(): string {
    return this._merchantId;
  }

  set merchantId(value: string) {
    this._merchantId = value;
  }

  get merchantName(): string {
    return this._merchantName;
  }

  set merchantName(value: string) {
    this._merchantName = value;
  }

  get apiKey(): string {
    return this._apiKey;
  }

  set apiKey(value: string) {
    this._apiKey = value;
  }

  get loginId(): string {
    return this._loginId;
  }

  set loginId(value: string) {
    this._loginId = value;
  }

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }

  toMap(){
    return {
      'merchantId' : this.merchantId ? this.merchantId : null,
      'merchantName' : this.merchantName ? this.merchantName : null,
      'apiKey' : this.apiKey ? this.apiKey : null,
      'loginId' : this.loginId ? this.loginId : null,
      'password' : this.password ? this.password : null,
    };
  }
}

export class StaticQr {

  public merchantId: string;
  public merchantName: string;
  public staticQrImage: string;
  public providerName: string;
  public providerLogo: string;

  constructor() {
    this.merchantId = '';
    this.merchantName = '';
    this.staticQrImage = '';
    this.providerName = '';
    this.providerLogo = '';
  }

  clone(data: StaticQr) {
    this.merchantId = data.merchantId;
    this.merchantName = data.merchantName;
    this.staticQrImage = data.staticQrImage;
    this.providerName = data.providerName;
    this.providerLogo = data.providerLogo;

  }

  fromJson(data: StaticQr){
    this.merchantId = GetSafeValue.getSafeValueAsString(data["merchantId"], null);
    this.merchantName = GetSafeValue.getSafeValueAsString(data["merchantName"], null);
    this.staticQrImage = GetSafeValue.getSafeValueAsString(data["staticQrImage"], null);
    this.providerName = GetSafeValue.getSafeValueAsString(data["providerName"], null);
    this.providerLogo = GetSafeValue.getSafeValueAsString(data["providerLogo"], null);


  }

  toMap(){
    return {
      'merchantId' : this.merchantId ? this.merchantId : null,
      'merchantName' : this.merchantName ? this.merchantName : null,
      'staticQrImage' : this.staticQrImage ? this.staticQrImage : null,
      'providerName' : this.providerName ? this.providerName : null,
      'providerLogo' : this.providerLogo ? this.providerLogo : null,
    };
   }
 }
